export enum FieldType {
    String,
    Date,
    Integer,
    PositiveDouble,
    Double,
    DateOrInteger,
    Boolean
}
